import React from 'react';
import "./style/css/reset.css";
import {Route, Switch} from "react-router-dom";
import {MainContainer, ResultContainer} from "./pages";
import styled from 'styled-components';

const App = () => {
    return (
        <Switch>
            <Wrap>
                <Route exact path="/">
                    <MainContainer/>
                </Route>
                <Route exact path="/result/:type">
                    <ResultContainer/>
                </Route>
            </Wrap>
        </Switch>
    );
};

const Wrap = styled.div`
    width: 375px;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding-bottom: 20px;

    @media screen and (max-width: 760px) {
        width: 100vw;
    }
`;

export default App;
